import { config } from '@common/config';
import * as moment from 'moment';

const LOCAL_STORAGE_KEY = 'lastAction';

export class Timer {
  private readonly millisecondsUntilPopup = config.minutesUntilLogoutPopup * 60 * 1000;
  private readonly millisecondsUntilLogout = config.minutesUntilAutoLogout * 60 * 1000 - this.millisecondsUntilPopup;

  private activeTimer: NodeJS.Timer;
  private activeTime: string;
  private popupTimer: number;
  private logoutTimer: number;
  private expectedLastAction: number;

  private onBeforeExpired: Function;
  private onExpired: Function;
  private onBeforeReset: Function;
  private setTime: Function;

  get lastAction() {
    return parseInt(localStorage.getItem(LOCAL_STORAGE_KEY) || '', undefined) || 0;
  }
  set lastAction(value: number) {
    localStorage.setItem(LOCAL_STORAGE_KEY, value.toString());
  }

  get getTime() {
    return this.activeTime;
  }

  constructor(onExpired: Function, onBeforeExpired: Function, onBeforeReset: Function, setTime: Function) {
    this.onBeforeExpired = onBeforeExpired;
    this.onExpired = onExpired;
    this.onBeforeReset = onBeforeReset;
    this.setTime = setTime;
  }

  checkPopupTimer() {
    const currentLastAction = this.lastAction;
    const currentElapsed = Date.now() - currentLastAction;
    if (currentLastAction !== this.expectedLastAction) {
      // this will happen if another tab has activity
      const newTimeout = this.millisecondsUntilPopup - currentElapsed;
      this.reset(true);
      setTimeout(this.checkPopupTimer.bind(this), newTimeout);
      this.expectedLastAction = currentLastAction;
    } else {
      const newTimeout = this.millisecondsUntilPopup + this.millisecondsUntilLogout - currentElapsed;
      this.onBeforeExpired();
      this.logoutTimer = setTimeout(this.checkLogoutTimer.bind(this), newTimeout);
    }
  }

  initialize() {
    clearInterval(this.activeTimer);
    this.popupTimer = setTimeout(this.checkPopupTimer.bind(this), this.millisecondsUntilPopup);
    const startTimeMS = new Date().getTime();
    this.activeTimer = setInterval(() => {
      this.activeTime = moment('2000-01-01 00:00:00')
        .add(moment.duration(new Date().getTime() - startTimeMS, 'milliseconds'))
        .format('HH:mm:ss');
      this.setTime(this.activeTime);
    }, 1000);
    var now = Date.now();
    this.lastAction = now;
    this.expectedLastAction = now;
  }

  checkLogoutTimer() {
    const currentLastAction = this.lastAction;
    if (currentLastAction !== this.expectedLastAction) {
      this.checkPopupTimer();
    } else {
      this.onExpired();
      clearInterval(this.activeTimer);
    }
  }

  reset(stopping?: boolean) {
    clearInterval(this.activeTimer);
    clearTimeout(this.popupTimer);
    clearTimeout(this.logoutTimer);
    this.onBeforeReset();
    const startTimeMS = new Date().getTime();
    this.activeTimer = setInterval(() => {
      this.activeTime = moment('2000-01-01 00:00:00')
        .add(moment.duration(new Date().getTime() - startTimeMS, 'milliseconds'))
        .format('HH:mm:ss');
      this.setTime(this.activeTime);
    }, 1000);

    if (!stopping) {
      this.initialize();
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/timer.ts